export default __webpack_public_path__ + "static/media/misuse-of-it-systems.1f7fcc1e.svg";